export default "__VITE_ASSET__BuJp6TWu__"